import React from 'react';

interface LegendIconProps {
  color: string;
  useGradient?: boolean;
}

export const LegendIcon: React.FC<LegendIconProps> = ({ color, useGradient }) => {
  const boxStyle: React.CSSProperties = {
    width: '10px',
    height: '10px',
    ...(useGradient
      ? { backgroundImage: `linear-gradient(90deg, ${color} 50%, white 50%)` }
      : { backgroundColor: color }),
    backgroundSize: '4px 4px',
  };

  return <div style={boxStyle} />;
};

LegendIcon.defaultProps = {
  useGradient: false,
};
